<template>
  <div class="page-cont">
    <!-- Banner 容器 -->
    <div class="banner-container">
        <!-- 左侧：热门板块 -->
        <div class="banner-column">
            <div class="widget-header">
                <span class="title-hot">🔥 热门项目</span>
                <!-- <a href="/hot" style="font-size: 13px; color: #999; text-decoration: none;">更多>></a> -->
            </div>
            <ul class="post-grid">
                <!-- 文章项 1 -->
                <li>
                    <router-link to="/blog/rollercoin" class="post-item">
                        <img src="../assets/img/rollercover.webp" alt="缩略图" class="post-thumbnail">
                        <div class="post-content">
                            <span class="post-title">Rollercoin 新手攻略</span>
                        </div>
                      </router-link>
                </li>
                <!-- 文章项 2 -->
                <li>
                    <router-link to="/blog/sunflowerland" class="post-item">
                        <img src="../assets/img/sunflowercover.webp" alt="缩略图" class="post-thumbnail">
                        <div class="post-content">
                            <span class="post-title">sunflower land 新手攻略</span>
                        </div>
                      </router-link>
                </li>
                <!-- 文章项 3 -->
                <li>
                    <router-link to="/blog/pinetwork" class="post-item">
                        <img src="../assets/img/picover.webp" alt="缩略图" class="post-thumbnail">
                        <div class="post-content">
                            <span class="post-title">Pi Network从手机挖矿到AI算力网络的进化之路</span>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>

        <!-- 右侧：最新板块 -->
        <div class="banner-column">
            <div class="widget-header">
                <span class="title-new">⏰ 最新发布</span>
                <!-- <a href="/new" style="font-size: 13px; color: #999; text-decoration: none;">更多>></a> -->
            </div>
            <ul class="post-grid">
                <!-- 文章项 1 -->
                <li>
                    <router-link to="/blog/digital" class="post-item">
                        <img src="../assets/img/shuzi.webp" alt="缩略图" class="post-thumbnail">
                        <div class="post-content">
                            <span class="post-title">数字资产未来会如何发展</span>
                        </div>
                    </router-link>
                </li>
                <!-- 文章项 2 -->
                <li>
                    <router-link to="/blog/intelligence" class="post-item">
                        <img src="../assets/img/ailicai.webp" alt="缩略图" class="post-thumbnail">
                        <div class="post-content">
                            <span class="post-title">AI与理财的碰撞</span>
                        </div>
                    </router-link>
                </li>
                <!-- 文章项 3 -->
                <li>
                    <router-link to="/blog/web3" class="post-item">
                        <img src="../assets/img/web3cover.webp" alt="缩略图" class="post-thumbnail">
                        <div class="post-content">
                            <span class="post-title">WEB3发展趋势</span>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>

    </div>

    <div class="container">
    <ul class="blog-list">
        <!-- 博客文章 1 -->
        <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/rollercover.webp" alt="滚动币">
            </div>
            <div class="blog-content">
                <h2 class="blog-title">
                  <router-link to="/blog/rollercoin">rollercoin 新手攻略</router-link>
                  <!-- <a href=""></a> -->
                </h2>
                <div class="blog-meta">
                    <span>发布于：2026年3月5日</span>
                    <span>分类：链游挖矿</span>
                </div>
                <p class="blog-excerpt">RollerCoin 是一款挖矿游戏，它的目的是让你在游戏中获得乐趣，并以真实的加密货币获得奖励。</p>
                <router-link to="/blog/rollercoin" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
        <!-- 博客文章 2 -->
        <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/sunflowercover.webp" alt="sunflower land">
            </div>
            <div class="blog-content">
                <h2 class="blog-title"><router-link to="/blog/sunflowerland">sunflower land 新手攻略</router-link></h2>
                <div class="blog-meta">
                    <span>发布于：2026年3月1日</span>
                    <span>分类：链游</span>
                </div>
                <p class="blog-excerpt">
                    在向日葵乐园种植、制作并赚钱——唯一由社区控制代币、NFT 和资源的区块链游戏。
                </p>
                <router-link to="/blog/sunflowerland" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
        <!-- 博客文章 3 -->
        <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/picover.webp" alt="pinetwork">
            </div>
            <div class="blog-content">
                <h2 class="blog-title"><router-link to="/blog/pinetwork">Pi Network从手机挖矿到AI算力网络的进化之路</router-link></h2>
                <div class="blog-meta">
                    <span>发布于：2026年2月20日</span>
                    <span>分类：技术趋势</span>
                </div>
                <p class="blog-excerpt">
                    Pi Network 是一个于 2019 年发起的加密货币项目，其最大特点是用户可以通过手机 App 进行“挖矿”，而无需消耗大量计算能力和电力。
                </p>
                <router-link to="/blog/pinetwork" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
        <!-- 博客文章 4 -->
        <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/web3cover.webp" alt="web3">
            </div>
            <div class="blog-content">
                <h2 class="blog-title"><router-link to="/blog/web3">WEB3发展趋势</router-link></h2>
                <div class="blog-meta">
                    <span>发布于：2026年2月10日</span>
                    <span>分类：技术趋势</span>
                </div>
                <p class="blog-excerpt">
                    Web3的发展已经超越了早期的加密货币叙事，进入了一个以实用性、合规性与技术融合为核心的新阶段。行业焦点正从“构建加密原生应用”转向“利用加密技术解决现实世界问题”，并深度融入主流商业和金融体系。
                </p>
                <router-link to="/blog/web3" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
        <!-- 文章5 -->
         <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/ailicai.webp" alt="web3">
            </div>
            <div class="blog-content">
                <h2 class="blog-title"><router-link to="/blog/intelligence">AI与理财的碰撞</router-link></h2>
                <div class="blog-meta">
                    <span>发布于：2026年3月10日</span>
                    <span>分类：趋势分析</span>
                </div>
                <p class="blog-excerpt">
                    AI与理财的碰撞，正从简单的“信息查询”进化为深刻的“服务重构”。这场碰撞不仅是技术的升级，更是理财服务模式、风险格局和行业生态的全面重塑。我们正见证着理财服务从“专家专属”走向“大众普惠”，从“被动响应”走向“主动规划”。
                </p>
                <router-link to="/blog/intelligence" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
        <!-- 文章6 -->
         <li class="blog-item">
            <div class="blog-cover">
                <img src="../assets/img/shuzi.webp" alt="web3">
            </div>
            <div class="blog-content">
                <h2 class="blog-title"><router-link to="/blog/digital">数字资产未来会如何发展</router-link></h2>
                <div class="blog-meta">
                    <span>发布于：2026年3月15日</span>
                    <span>分类：趋势分析</span>
                </div>
                <p class="blog-excerpt">
                   数字资产（Digital Assets）正在经历从“投机代币”向“基础设施价值”的历史性跨越。随着 Web3.0、元宇宙和央行数字货币（CBDC）的兴起，数字资产不再仅仅是比特币或以太坊的价格波动，而是正在重塑全球金融体系、社会治理和个人数据主权的基石。
                </p>
                <router-link to="/blog/digital" class="read-more">继续阅读 →</router-link>
            </div>
        </li>
    </ul>
    
  </div>  
  </div>
  
</template>

<script>
/**
 * 逻辑部分 (Script)
 * 定义组件的数据、方法、生命周期钩子等
 */
export default {
  name: 'MyHome', // 组件名称，用于调试和递归组件
  data() {
    // data 必须是一个函数，以避免多个实例间的数据共享
    return {
      title: '实现被动收入，迈向财富自由',
      showMessage: true,
      
    }
  },
  methods: {
    // 定义事件处理函数
    updateTitle(newTitle) {
      this.title = newTitle;
    }
  },
  mounted() {
    // 组件挂载到 DOM 后执行
    console.log('组件已挂载');
  }
}
</script>

<style scoped>
/**
 * 样式部分 (Style)
 * scoped 属性确保样式仅作用于当前组件，避免全局污染
 */

.page-cont{
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
 }

.container {
  padding: 20px;
  background-color: #2f3045;
}

/* Banner 容器 */
.banner-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 0 20px;
    display: flex;
    gap: 30px; /* 左右板块间距 */
}

/* 左右板块通用样式 */
.banner-column {
    flex: 1;
    background-color: #2f3045;
    box-shadow: 0 4px 12px rgba(7, 225, 228, 0.05);
    overflow: hidden;
    /* border: 2px solid #ffdc00; */
      animation: breathe 2.5s ease-in-out infinite;
}

/* 板块头部 */
.widget-header {
    padding: 16px 20px;
    /* background-color: #07e1e4; */
    background-color: #ffdc00;
    border-bottom: 1px solid #eee;
    font-size: 18px;
    font-weight: bold;
    color: #2c3e50;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.banner-column:last-child{
  animation: breathe2 2.5s ease-in-out infinite;
}
.banner-column:last-child .widget-header{
  background-color: #07e1e4;
}

.widget-header .title-hot { color: #e74c3c; }
.widget-header .title-new { color: #3498db; }

/* 文章列表 */
.post-grid {
    list-style: none;
    padding: 10px 0;
}

.post-grid li:last-child .post-item{
  border: none;
}

.post-item {
    display: flex;
    padding: 12px 20px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s, transform 0.2s;
    text-decoration: none;
    color: #333;
    gap: 15px;
}

.post-item:hover {
    /* background-color: #fdfdfd; */
    transform: translateX(5px);
}

/* 缩略图样式 */
.post-thumbnail {
    flex-shrink: 0; /* 防止图片被压缩 */
    width: 80px;
    height: 60px;
    border-radius: 6px;
    object-fit: cover; /* 保证图片比例填充 */
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* 文章内容（标题） */
.post-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
}

.post-title {
    font-size: 15px;
    color: #fff;
    font-weight: 500;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 最多显示2行 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

        
.blog-list {
    list-style: none;
}

.blog-item {
    display: flex;
    padding: 25px 0;
    border-bottom: 1px solid #07e1e4;
    transition: transform 0.2s ease;
    gap: 25px;
}

.blog-item:hover {
    transform: translateY(-2px);
}

.blog-item:last-child {
    border-bottom: none;
}

.blog-cover {
    flex: 0 0 200px;
    height: 150px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    flex-shrink: 0;
}



.blog-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.blog-item:hover .blog-cover img {
    transform: scale(1.05);
}

.blog-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.blog-title {
    font-size: 24px;
    margin-bottom: 10px;
    color: #fff;
    text-decoration: none;
    display: inline-block;
    transition: color 0.2s ease;
}

.blog-title:hover {
    color: #3498db;
}

.blog-meta {
    display: flex;
    gap: 15px;
    font-size: 14px;
    margin-bottom: 15px;
    color: #03e1e4;
}

.blog-excerpt {
    color: #fff;
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 15px;
    flex-grow: 1;
}

.read-more {
    color: #3498db;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: gap 0.2s ease;
    align-self: flex-start;
    padding: 8px 16px;
    border: 1px solid #3498db;
    border-radius: 4px;
}

.read-more:hover {
    gap: 10px;
    background-color: #3498db;
    color: #fff;
}
/* 响应式：在小屏幕上变为上下堆叠 */
@media (max-width: 768px) {
    .banner-container {
        flex-direction: column;
    }
    
    .post-item {
        padding: 10px 15px;
    }
    
    .post-thumbnail {
        width: 70px;
        height: 52px;
    }
    .blog-item{
        flex-direction: column;
    }
}

/* 呼吸动画关键帧 */
@keyframes breathe {
    0% {
        /* 初始状态：阴影较小，透明度正常 */
        box-shadow: 0 1px 4px rgba(251, 220, 0, 0.2);
        opacity: 0.8;
    }
    50% {
        /* 中间状态：阴影变大、颜色变亮，模拟“吸气”发光 */
        box-shadow: 0 0 10px 4px rgba(255, 220, 0, 0.6);
        opacity: 1;
    }
    100% {
        /* 结束状态：阴影恢复，模拟“呼气”变暗 */
        box-shadow: 0 1px 4px rgba(251, 220, 0, 0.2);
        opacity: 0.8;
    }
}

/* 呼吸动画关键帧 */
@keyframes breathe2 {
    0% {
        /* 初始状态：阴影较小，透明度正常 */
        box-shadow: 0 1px 4px rgba(3, 225, 228, 0.2);
        opacity: 0.8;
    }
    50% {
        /* 中间状态：阴影变大、颜色变亮，模拟“吸气”发光 */
        box-shadow: 0 0 10px 4px rgba(7, 225, 228, 0.6);
        opacity: 1;
    }
    100% {
        /* 结束状态：阴影恢复，模拟“呼气”变暗 */
        box-shadow: 0 1px 4px rgba(3, 225, 228, 0.2);
        opacity: 0.8;
    }
}
</style>